import airtableIcon from "../../assets/integrations/airtable.png";
import activeCampaignIcon from "../../assets/integrations/activecampaign.png";
import benchmarkIcon from "../../assets/integrations/benchmark.png";
import beehiivIcon from "../../assets/integrations/beehiiv.jpeg";
import brevoIcon from "../../assets/integrations/brevo.png";
import clickFunnelsIcon from "../../assets/integrations/clickfunnels.png";
import dripIcon from "../../assets/integrations/drip.png";
import emailOctopusIcon from "../../assets/integrations/emailoctopus.png";
import emercuryIcon from "../../assets/integrations/emercury.jpeg";
import fluentCrmIcon from "../../assets/integrations/fluentcrm.png";
import gistIcon from "../../assets/integrations/gist.png";
import getResponseIcon from "../../assets/integrations/getresponse.png";
import goHighLevelIcon from "../../assets/integrations/gohighlevel.png";
import googleSheetIcon from "../../assets/integrations/Google Sheets.webp"
import hubspotIcon from "../../assets/integrations/hubspot.jpeg";
import hyrosIcon from "../../assets/integrations/hyros.png";
import klaviyoIcon from "../../assets/integrations/klaviyo.png";
import kitIcon from "../../assets/integrations/kit.png";
import lemlistIcon from "../../assets/integrations/lemlist.png";
import mailchimpIcon from "../../assets/integrations/mailchimp.png";
import mailerliteIcon from "../../assets/integrations/mailerlite.jpeg";
import mailpoetIcon from "../../assets/integrations/mailpoet.png";
import mailsterIcon from "../../assets/integrations/mailster.png";
import moosendIcon from "../../assets/integrations/moosend.png";
import omnisendIcon from "../../assets/integrations/omnisend.png";
import pabblyIcon from "../../assets/integrations/pabbly.webp";
import platformlyIcon from "../../assets/integrations/platformly.png";
import sendFoxIcon from "../../assets/integrations/sendfox.png";
import sendgridIcon from "../../assets/integrations/sendgrid.png";
import sendpulseIcon from "../../assets/integrations/sendpulse.png";
import snovIcon from "../../assets/integrations/snov.png";
import systemeIcon from "../../assets/integrations/systeme.png";
import zohoIcon from "../../assets/integrations/zoho.png";

export const HELP_ROOT = "https://groupboss.io/help/";

const field = (payloadKey, label, options = {}) => ({
  name: payloadKey,
  payloadKey,
  label,
  placeholder: options.placeholder || "",
  type: options.type || "text",
  required: options.required !== false,
});

const provider = (key, label, icon, fields, options = {}) => ({
  key,
  label,
  description: options.description || `Connect ${label} to your Groupboss groups.`,
  category: options.category || "Marketing automation",
  icon,
  setupGuide: options.setupGuide || HELP_ROOT,
  helpVideoUrl: options.helpVideoUrl || process.env.REACT_APP_INTEGRATIONS_HELP_VIMEO_URL || "",
  aliases: options.aliases || [],
  fields,
});

const integrationCatalog = [
  provider("google-sheet", "Google Sheet", googleSheetIcon, [
    field("gurl", "Google Sheet URL", { type: "url", placeholder: "https://docs.google.com/spreadsheets/d/..." }),
  ], { category: "Data sync", aliases: ["group_list"], description: "Send group data to a Google Sheet.", setupGuide: "https://groupboss.io/help/integrate-groupboss-with-google-sheet/" }),
  provider("mailchimp", "Mailchimp", mailchimpIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("username", "Username"),
    field("list_id", "Audience ID"),
    field("tag_name", "Tag Name", { required: false }),
  ], { description: "Send new group leads to a Mailchimp audience.", setupGuide: "https://groupboss.io/help/integrate-groupboss-with-mailchimp/" }),
  provider("activecampaign", "ActiveCampaign", activeCampaignIcon, [
    field("url", "API URL", { type: "url", placeholder: "https://groupboss.api-us1.com" }),
    field("list_id", "List ID"),
    field("api_key", "API Key", { type: "password" }),
    field("tag_name", "Tag Name", { required: false }),
  ], { description: "Create contacts and tags in ActiveCampaign.", setupGuide: "https://groupboss.io/help/integrate-groupboss-with-activecampaign/" }),
  provider("getresponse", "GetResponse", getResponseIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("campaign_id", "List Token"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-getresponse/" }),
  provider("kit", "Kit", kitIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("form_id", "Form ID"),
  ], { description: "Find and connect with your true fans faster with Kit.", setupGuide: "https://groupboss.io/help/integrate-groupboss-with-convertkit/" }),
  provider("lemlist", "Lemlist", lemlistIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("campaign_id", "Campaign ID"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-lemlist/" }),
  provider("snov.io", "Snov.io", snovIcon, [
    field("client_id", "API User ID"),
    field("client_secret", "API Secret", { type: "password" }),
    field("list_id", "List ID"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-snovio/" }),
  provider("sendfox", "SendFox", sendFoxIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("list_id", "List ID"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-sendfox/" }),
  provider("moosend", "Moosend", moosendIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("mailing_list_id", "Mailing List ID"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-moosend/" }),
  provider("mailerlite", "MailerLite", mailerliteIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("group_id", "Group ID"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-mailerlite/" }),
  provider("sendgrid", "SendGrid", sendgridIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("list_id", "List ID"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-sendgrid/" }),
  provider("brevo", "Brevo", brevoIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("list_id", "List ID"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-sendinblue/" }),
  provider("klaviyo", "Klaviyo", klaviyoIcon, [
    field("private_api_key", "Private API Key", { type: "password" }),
    field("list_id", "List ID"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-klaviyo/" }),
  provider("drip", "Drip", dripIcon, [
    field("api_token", "API Token", { type: "password" }),
    field("account_id", "Account ID"),
    field("tag_name", "Tag Name", { required: false }),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-drip/" }),
  provider("hyros", "Hyros", hyrosIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("tag_name", "Tag Name"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-hyros/" }),
  provider("gist", "Gist", gistIcon, [
    field("api_token", "API Key", { type: "password" }),
    field("tag_name", "Tag Name"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-gist/" }),
  provider("pabbly", "Pabbly", pabblyIcon, [
    field("access_token", "Access Token", { type: "password" }),
    field("list_name", "List Name"),
  ], { setupGuide: "https://groupboss.io/help/integrate-groupboss-with-pabbly/" }),
  provider("gohighlevel", "GoHighLevel", goHighLevelIcon, [
    field("bearer_token", "API Key", { type: "password" }),
    field("tag_name", "Tag Name"),
  ], { category: "CRM", setupGuide: "https://groupboss.io/help/integrate-groupboss-with-gohighlevel/" }),
  provider("gohighlevelv2", "GoHighLevel API V2", goHighLevelIcon, [
    field("bearer_token", "Access Token", { type: "password" }),
    field("locationId", "Location ID"),
    field("tag_name", "Tag Name"),
  ], { category: "CRM", setupGuide: "https://groupboss.io/help/integrate-groupboss-with-gohighlevel-v2/" }),
  provider("emailoctopus", "Email Octopus", emailOctopusIcon, [
    field("list_id", "List ID"),
    field("api_key", "API Key", { type: "password" }),
    field("tag_name", "Tag Name", { required: false }),
  ], { setupGuide: "https://groupboss.io/help/emailoctopus-groupboss-integration/" }),
  provider("omnisend", "Omnisend", omnisendIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("tag_name", "Tag Name"),
  ], { setupGuide: "https://groupboss.io/help/omnisend-and-groupboss-integration/" }),
  provider("benchmarkemail", "Benchmark Email", benchmarkIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("list_id", "List ID"),
  ], { setupGuide: "https://groupboss.io/help/groupboss-benchmark-email-integration/" }),
  provider("clickfunnels", "ClickFunnels", clickFunnelsIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("workspace_id", "Workspace ID"),
    field("tag_id", "Tag ID", { required: false }),
  ], { setupGuide: "https://groupboss.io/help/clickfunnels-and-groupboss-integration/" }),
  provider("systeme.io", "Systeme.io", systemeIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("tag_name", "Tag Name", { required: false }),
  ], { setupGuide: "https://groupboss.io/help/how-to-integrate-groupboss-with-systeme-io/" }),
  provider("beehiiv", "Beehiiv", beehiivIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("pub_id", "Publication ID"),
  ], {setupGuide: "https://groupboss.io/help/with-the-help-of-the-following-steps-you-will-be-able-to-do-the-integration-of-groupboss-with-beehiiv/"}),
  provider("hubspot", "HubSpot", hubspotIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("list_id", "List ID", { required: false }),
  ], { category: "CRM", setupGuide: "https://groupboss.io/help/hubspot-integration-with-groupboss/" }),
  provider("platform.ly", "Platform.ly", platformlyIcon, [
    field("api_key", "API Key", { type: "password" }),
    field("project_id", "Project ID"),
    field("tag_id", "Tag ID", { required: false }),
    field("segment_id", "Segment ID", { required: false }),
  ], { setupGuide: "https://groupboss.io/help/groupboss-and-platformly-integration/" }),
  provider("airtable", "Airtable", airtableIcon, [
    field("access_token", "Access Token", { type: "password" }),
    field("base_id", "Base ID"),
    field("table_id", "Table ID"),
  ], { setupGuide: "https://groupboss.io/help/airtable-integration-with-groupboss/" }),
  provider("emercury", "Emercury", emercuryIcon, [
    field("email", "Emercury Email", { type: "email" }),
    field("api_key", "API Key", { type: "password" }),
    field("list_id", "List ID (Audience ID)"),
  ], { setupGuide: "https://help.emercury.net/en/articles/2678141-how-to-request-an-api-key "}),
  provider("zohocrm", "Zoho CRM", zohoIcon, [
    field("client_id", "Client ID"),
    field("client_secret", "Client Secret", { type: "password" }),
    field("code", "Code", { type: "password" }),
  ], { category: "CRM", setupGuide: "https://groupboss.io/help/zoho-crm-integration-with-groupboss/" }),
  provider("sendpulse", "Sendpulse", sendpulseIcon, [
    field("api_id", "API ID"),
    field("api_secret", "API Secret", { type: "password" }),
    field("list_id", "List ID"),
  ], {setupGuide: "https://groupboss.io/help/sendpulse-integration-with-groupboss/" }),
  provider("fluentcrm", "FluentCRM", fluentCrmIcon, [
    field("site_url", "Site URL", { type: "url" }),
    field("api_username", "API Username"),
    field("api_password", "API Password", { type: "password" }),
    field("list_id", "List ID"),
    field("tag_id", "Tag ID", { required: false }),
  ], { setupGuide: "https://groupboss.io/help/fluentcrm-integration-with-groupboss/" }),
  provider("mailpoet", "MailPoet", mailpoetIcon, [
    field("site_url", "Site URL", { type: "url" }),
    field("activation_key", "Activation Key", { type: "password" }),
    field("list_id", "List ID"),
    field("double_optin", "Already configured WordPress REST API?", { type: "checkbox", required: false }),
  ], { setupGuide: "https://groupboss.io/help/mailpoet-integration-with-groupboss/" }),
  provider("mailster", "Mailster", mailsterIcon, [
    field("site_url", "Site URL", { type: "url" }),
    field("list_id", "List ID"),
    field("double_optin", "Already configured WordPress REST API?", { type: "checkbox", required: false }),
  ], { setupGuide: "https://groupboss.io/help/mailster-integration-with-groupboss/" }),
];

export const getCanonicalProviderKey = (key) => {
  if (key === "group_list") return "google-sheet";
  return key;
};

export default integrationCatalog;
